/**
 * Custom Query API Endpoints
 * Handles custom database queries and CSV exports.
 */
import type { AxiosResponse } from "axios";
import api from "../api";
import type { EntityPayload } from "../../types/api";

export const customQueryApi = {
  /** Get data by seminar. */
  getBySeminar: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post("/api/customquery/getbyseminar", { data }),

  /** Get customer by parameter. */
  getCustomerByParam: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post("/api/customquery/getcustomerbyparam", { data }),

  /** Search emails (clients/participants) by a full query. */
  searchEmails: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post("/api/customquery/searchemails", { data }),

  /** Partial (type-ahead) email search. */
  partialSearchEmails: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post("/api/customquery/partial-search-emails", { data }),

  /** Export emails to CSV. */
  exportEmails: (data: EntityPayload): Promise<AxiosResponse> =>
    api.post("/api/export/email", { data }),

  /** Export invoices to CSV. */
  exportInvoices: (data: EntityPayload): Promise<AxiosResponse> =>
    // The accounting CSV export route is /api/export/rechnung (the controller
    // reads { from, to } from body.data). There is no /api/invoiceexport route.
    api.post("/api/export/rechnung", { data }),
};
